import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { PageWrapper } from '@/shared/ui/page-wrapper'
import { CatalogMenuWidget } from '@/widgets/catalog-menu-widget'

export const Route = createFileRoute('/_auth/canteen/menu-settings/catalog-menu/')({
  staticData: {
    meta: {
      title: 'Каталог меню',
      description: '',
    },
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { t } = useTranslation()

  return (
    <PageWrapper title={t('Каталог меню')}>
      <CatalogMenuWidget />
    </PageWrapper>
  )
}
